export default () => {
  return {
    count: () => {},
    timing: () => {},
    gauge: () => {},
    addGlobalTags: () => {},
    sendPagePerformance: () => {},
    sendInitialLoadTime: () => {},
    flush: () => {},
  };
};



// WEBPACK FOOTER //
// ./src/providers/disabled.js